<dialog-gala (clickClose)="hideModal()">
  <span gala-dialog-titre>{{lgTrad.TITRE}}</span>
  <div>
    <div class="row d-flex align-items-center justify-content-center flex-nowrap">
      <div class="offset-1">
        <div-info-client #infosClient [idClient]="client?.IDCLIENT" [margesReduites]="true" />
      </div>
      <div class="btn-group-vetical btn-group-sm col-1 top-n10px">
        <div class="mb-2">
          <gala-btn title="{{translate.instant('APPCLIENT.INVENTAIRE')}}" (click)="nouvellePage(1)"
            [medium]="true">
            <i class="fas fa-list-alt"></i>
          </gala-btn>
        </div>
        <div class="mb-2">
          <gala-btn title="{{translate.instant('APPCLIENT.ACTIVITE')}}" (click)="nouvellePage(2)" [disabled]="!this.accesSuiviActivite"
            [medium]="true">
            <i class="fas fa-clipboard-check"></i>
          </gala-btn>
        </div>
        <div class="mb-2">
          @if (droitsAccess.write) {
            <gala-btn-edit (click)="nouvellePage(3)" title="{{translate.instant('APPCLIENT.DONNECL')}}"
              [medium]="true" />
            } @else {
              <gala-btn-search (click)="nouvellePage(3)"
                title="{{translate.instant('APPCLIENT.DONNECL')}}" [medium]="true" />
              }
            </div>
          </div>
        </div>

        <accordion-gala [multiple]="true">
          <!-- Données générales -->
          <accordion-gala-item [collapsed]="false">
            <accordion-gala-item-head>{{lgTrad.GENEDATAS}}</accordion-gala-item-head>
            <accordion-gala-item-body>
              <client-donnees-gen #donneesGen (rfService)="openService($event)"
                (service)="openEditService($event)" (installations)="openInstallations()" />
              </accordion-gala-item-body>
            </accordion-gala-item>

            <!-- Groupes -->
            <accordion-gala-item [collapsed]="false">
              <accordion-gala-item-head>{{lgTrad.GROUPES}}</accordion-gala-item-head>
              <accordion-gala-item-body>
                <client-groupes #groupes />
              </accordion-gala-item-body>
            </accordion-gala-item>

            <!-- Surfaces -->
            <accordion-gala-item [collapsed]="false">
              <accordion-gala-item-head>{{lgTrad.SURFACES}}</accordion-gala-item-head>
              <accordion-gala-item-body>
                <client-surfaces #surfaces />
              </accordion-gala-item-body>
            </accordion-gala-item>

            <!-- Races -->
            <accordion-gala-item [collapsed]="false">
              <accordion-gala-item-head>{{lgTrad.RACES}}</accordion-gala-item-head>
              <accordion-gala-item-body>
                <client-races #races />
              </accordion-gala-item-body>
            </accordion-gala-item>

          </accordion-gala>
        </div>
        <div gala-dialog-actions>
          <button mat-stroked-button color="accent" (click)="hideModal()">{{lgTrad.RET}}</button>
        </div>
      </dialog-gala>
